/* import __COLOCATED_TEMPLATE__ from './select-list.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@ember/component';
import { computed } from '@ember/object';
import { ExternalBankAccount } from '@square/dashboard-protos/models/squareup/sfs/external/models/external_bank_account';
import { inject as service } from '@ember/service';
import { Account } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { OwnerType, AccountType, AccountState } from '@square/dashboard-protos/models/squareup/banking/common';
let SelectList = (_dec = computed('accountOptions.length'), _dec2 = computed('accountOptions'), _dec3 = computed('balances'), _dec4 = computed('balances.length'), _dec5 = computed('locationSelector.units', 'balances'), (_class = class SelectList extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "accountOptions", void 0);
    _initializerDefineProperty(this, "locationSelector", _descriptor, this);
  }
  get balances() {
    const array = [];
    this.accountOptions.forEach(({
      account,
      id
    }) => {
      if (account instanceof Account) {
        array.push({
          id,
          account
        });
      }
    });
    return array;
  }
  get externalBankAccounts() {
    const array = [];
    this.accountOptions.forEach(option => {
      if (option.account instanceof ExternalBankAccount) {
        array.push(option);
      }
    });
    return array;
  }
  get savingsAccounts() {
    const array = [];
    this.balances.forEach(option => {
      if (option.account.type === AccountType.SAVINGS_ACCOUNT && option.account.state !== AccountState.CLOSED) {
        array.push(option);
      }
    });
    return array;
  }
  get foldersAccounts() {
    const array = [];
    this.balances.forEach(option => {
      if (option.account.type === AccountType.FOLDERS_ACCOUNT && option.account.state !== AccountState.CLOSED) {
        array.push(option);
      }
    });
    return array;
  }
  get locationAccounts() {
    if (!this.balances) {
      return [];
    }
    return this.balances.filter(({
      account
    }) => {
      if (account && account.owner) {
        return account.owner.type === OwnerType.UNIT && account.type !== AccountType.SAVINGS_ACCOUNT && account.type !== AccountType.CLEARING_ACCOUNT;
      } else {
        return false;
      }
    }).map(({
      account,
      id
    }) => {
      if (account && account.owner) {
        const unit = this.locationSelector.units.find(unit => {
          if (account && account.owner) {
            return unit.token === account.owner.id;
          } else {
            return false;
          }
        });
        if (!unit) {
          return null;
        }
        return {
          id,
          account: {
            availableBalance: account.availableBalance,
            unitNickname: unit.nickname,
            balanceType: account.type
          }
        };
      } else {
        return null;
      }
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "balances", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "balances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "externalBankAccounts", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "externalBankAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savingsAccounts", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "savingsAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "foldersAccounts", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "foldersAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationAccounts", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "locationAccounts"), _class.prototype)), _class));
export { SelectList as default };